import { render, staticRenderFns } from "./ConfirmRestorePopup.vue?vue&type=template&id=675c9fea&scoped=true"
import script from "./ConfirmRestorePopup.vue?vue&type=script&lang=js"
export * from "./ConfirmRestorePopup.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRestorePopup.vue?vue&type=style&index=0&id=675c9fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c9fea",
  null
  
)

export default component.exports